import React from "react";
import SharedFileSearch from "./SharedFileSearch/SharedFileSearch";

const SharedFilePage = () => <SharedFileSearch />;

export default SharedFilePage;
